import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { systemCode, xs_languageCode, xs_sessionToken } from '..';
import { AppContext } from '../App';
import { UserContext } from '../data/betslip/UserConf';
import { SeoContext } from '../data/seo/SeoContextProvider';
import { useAbsolutePath } from '../data/seo/seoRouteUtils';
import { classIf } from '../data/utils/classIf';
import { getConfiguration } from '../data/utils/configuration';
import { iconSportCssClass } from '../data/utils/iconSportCssClass';
import { appConfig } from '../appConfig';
import { labels } from '../data/labels';
import LandingMenuNavbar from '../prematch/main-menu/LandingMenuNavbar';
import { PrematchContext } from '../prematch/Prematch';
import SportSelection from './SportSelection';
import RaceSportButton from './RaceSportButton';

function SportSelector(props) {
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);
    const seoContext = React.useContext(SeoContext);
    const [showFilters, setShowFilters] = useState(false);
    const conf = getConfiguration();
    const userContext = useContext(UserContext);
    const user = userContext.getUser();
    // roulette game, other similar stuff
    const objectToAddInNavbar = {};
    const availableObjectTypes = {
    		'ROULETTE' : true,
    		'ROULETTE_VIDEO' : true,
    		'GENERIC_LINK' : true
    }
    
    if(conf.bfs && conf.bfs.fms.length > 0){
    	for(let kf in conf.bfs.fms){
    		const object = conf.bfs.fms[kf];
    		if(availableObjectTypes[object.typ] && object.enbm){
    			// searching for position
    			let positionInNavbar = 0;
				const mobilePosition = object.rmp;
				let availablePosition = false;
				if(mobilePosition){
					if(mobilePosition.indexOf('AFTER_SPORT_ON_POS_') === 0){
						// taking the position
						positionInNavbar = window.parseInt(mobilePosition.split('#')[1]);
						availablePosition = true;
					}
					else if(mobilePosition === 'TOP_LIST'){
						availablePosition = true;
					}
				}
				else{
					// backup handler: mobilePosition not specified
					availablePosition = true;
				}
				
				if(availablePosition){
					if(!objectToAddInNavbar[positionInNavbar]){
						objectToAddInNavbar[positionInNavbar] = [];
					}
					objectToAddInNavbar[positionInNavbar].push(object);
				}
    		}
    	}
    }
    

	
    const prematchPagePath = useAbsolutePath(appConfig.ROUTES.prematch['prematch'],null,null,true);


    function handleClick(){
        seoContext.refreshPathname(prematchPagePath,appContext.location.current);
    }
    
    function toggleFilters() {
        setShowFilters(!showFilters);
    }
    

    // If a time filter is set, only show the sports that match the filter
    let sports = prematchContext.applyTemporalFilter(props.data.sport);
    const dayFilterSelected = prematchContext.section === 'events-by-date';

    useEffect(() => {
        if (showFilters) {
            document.querySelector('html').classList.add('overflow-hidden');
        } else {
            document.querySelector('html').classList.remove('overflow-hidden');
        }
        return () => {
            document.querySelector('html').classList.remove('overflow-hidden');
        };
    }, [showFilters])

    
    // including the sports and the non-sport objects (roulette, links ecc)
    const finalSportList = [];
    let sportPosition = 0;
    for(let ks in sports){
    	if(sportPosition == 0){
    		// check if there are non-sport objects in TOP_LIST position
    		const nonSportObjs = objectToAddInNavbar[sportPosition];
    		if(nonSportObjs){
    			for(let ln in nonSportObjs){
    				finalSportList.push(nonSportObjs[ln]);
    			}
    		}    		
    	}
    	
    	sportPosition ++;
		finalSportList.push(sports[ks]);
		// check if there are non sport objects after this sport
		const nonSportObjs = objectToAddInNavbar[sportPosition];
		if(nonSportObjs){
			for(let ln in nonSportObjs){
				finalSportList.push(nonSportObjs[ln]);
			}
		}
	
    	
    }
    return (
        <>
            <div className="nav-slider-container">
                <nav id="nav-live-sports" className="nav-slider">
                    {dayFilterSelected &&
                        <div className="nav-slider-item-container sport-img-slider d-flex justify-content-center align-items-center selected">
                            <div className="d-flex justify-content-center align-items-center">
                                <img src={`${process.env.PUBLIC_URL}/assets/images/clock.png`} height="28px" width="28px" />
                            </div>
                            <div className="nav-slider-item">{prematchContext.temporalFilter.desc}</div>
                        </div>
                    }
                    {sports.length > 1 &&
                        <Link to={appConfig.ROUTES.prematch['prematch']} onClick={handleClick} >
                            <div className={"nav-slider-item-container sport-img-slider" + classIf(props.sport == null && !dayFilterSelected, 'selected')} onClick={() => {prematchContext.openMenu()}}>
                                <div className="sport-img-container">
                                    <div className={"sport-img "+ iconSportCssClass('All')}></div>
                                </div>
                                <div className="nav-slider-item">{labels['general.tutti']}</div>
                            </div>
                        </Link>
                    }
					<RaceSportButton />
                    {finalSportList.map((sport, index) => {
                    	const nonSportObject = sport.typ && availableObjectTypes[sport.typ];
                    	const roulette = sport.typ?.includes('ROULETTE');
                    	const genericLink = sport.typ === 'GENERIC_LINK';
                    	const styleGenericLink = {
                    			background : "url("  + sport.mic + ") no-repeat center",
                    	};
                    	let reactKey = nonSportObject? sport.typ : sport.id;
                    	const labelGeneric = sport.lmp && sport.lmp[xs_languageCode] ? sport.lmp[xs_languageCode] : "";
                        function handleClick() {
                        	if(!nonSportObject){
                        		prematchContext.openSport(sport);                        		
                        	}
                        	else {
                        		if(sport.typ?.includes('ROULETTE')){
                        			window.openRoulette();
                        		}
                        		else if(sport.typ === 'GENERIC_LINK'){
                        			const url = user.logged? sport.lurl : sport.uurl;
                        			window.open(url);
                        		}
                        	}
                        	
                        }
                        return <React.Fragment key={reactKey}>
                        {	
                        	nonSportObject?
                        	(
                        		<>
                        		{
                        			roulette &&(
	        	                    <div className={"nav-slider-item-container sport-img-slider"} onClick={() => { handleClick()}}>
		                                <div className="sport-img-container">
		                                    <div className={"roulette-button"}>
		                                        <div></div>
		                                    </div>
		                                </div>
		                                <div className="nav-slider-item">{labels['roulette.title']? labels['roulette.title'] : 'Live Roulette'}</div>
	                                </div>)
                        		}
                        		{
                        			genericLink && (
                        				<div className={"nav-slider-item-container sport-img-slider"} onClick={() => { handleClick()}}>
      		                                <div className="sport-img-container">
      		                                    <div className="generic-link-ico" style={styleGenericLink}> </div>
      		                                </div>
      		                                <div className="nav-slider-item">{labelGeneric}</div>
      	                                </div>
                        			)
                        		}
                        		</>

                        	)
                        	:
                        	(
                        			<SportSelection {...sport} counter={sport.eventsCount} selected={(props.sport && sport.id === props.sport.id)} handleClick={handleClick} />
                        	)
                        }
                            
                       </React.Fragment>
                    })}
                </nav>
                <div className="nav-slider-button" onClick={toggleFilters}>
                    {showFilters ?
                        <i className="fa fa-times"></i>
                        :
                        <>
                            <i className="fa fa-calendar-alt"></i>
                            <span>{prematchContext.temporalFilter.desc}</span>
                        </>
                    }
                </div>
                {showFilters &&
                    <LandingMenuNavbar close={() => setShowFilters(false)} />
                }
            </div>
            {showFilters &&
                <div className="sidebar-backdrop"></div>
            }
        </>
    );
}

export default SportSelector;